import api from "./http";

export async function getTwistHistory(params) {
    const response = await api.get("/api/twists/history", {params: params});
    return response.data;
};

export async function getVlTwistHistory() {
    const response = await api.get("/api/twists/history/value");
    return response.data;
};

export async function getVlTwistsByRare() {
    const response = await api.get("/api/twists/history/value/rare");
    return response.data;
};